import { defineTextStyles } from "@chakra-ui/react";
import { notoSansJpFontVariable } from "./variables";

export const textStyles = defineTextStyles({
  "Heading/Large": {
    value: {
      fontFamily: `var(${notoSansJpFontVariable})`,
      fontSize: "1.75rem",
      fontWeight: "700",
    },
  },
  "Heading/Medium": {
    value: {
      fontFamily: `var(${notoSansJpFontVariable})`,
      fontSize: "1.25rem",
      fontWeight: "700",
    },
  },
  "Heading/Small": {
    value: {
      fontFamily: `var(${notoSansJpFontVariable})`,
      fontSize: "1rem",
      fontWeight: "700",
    },
  },
  "Label/XLarge": {
    value: {
      fontFamily: `var(${notoSansJpFontVariable})`,
      fontSize: "1.25rem",
      fontWeight: "500",
    },
  },
  "Label/Large": {
    value: {
      fontFamily: `var(${notoSansJpFontVariable})`,
      fontSize: "1.125rem",
      fontWeight: "500",
    },
  },
  "Label/Medium": {
    value: {
      fontFamily: `var(${notoSansJpFontVariable})`,
      fontSize: "1rem",
      fontWeight: "500",
    },
  },
  "Label/Small": {
    value: {
      fontFamily: `var(${notoSansJpFontVariable})`,
      fontSize: "0.875rem",
      fontWeight: "500",
    },
  },
  "Label/XSmall": {
    value: {
      fontFamily: `var(${notoSansJpFontVariable})`,
      fontSize: "0.75rem",
      fontWeight: "500",
    },
  },
  "Paragraph/Large": {
    value: {
      fontFamily: `var(${notoSansJpFontVariable})`,
      fontSize: "1.125rem",
      fontWeight: "400",
    },
  },
  "Paragraph/Medium": {
    value: {
      fontFamily: `var(${notoSansJpFontVariable})`,
      fontSize: "1rem",
      fontWeight: "400",
    },
  },
  "Paragraph/Small": {
    value: {
      fontFamily: `var(${notoSansJpFontVariable})`,
      fontSize: "0.875rem",
      fontWeight: "400",
    },
  },
  "Paragraph/XSmall": {
    value: {
      fontFamily: `var(${notoSansJpFontVariable})`,
      fontSize: "0.75rem",
      fontWeight: "400",
    },
  },
});
